<template>
  <div class="wrapper">
    <!--    <input-->
    <!--      ref="input"-->
    <!--      :class="classwidth"-->
    <!--      :value="value"-->
    <!--      @input="update($event.target.value)"-->
    <!--      @blur="validateRange"-->
    <!--      :disabled="disabled"-->
    <!--    /><slot style="display: inline"></slot>-->

    <!--    <Input :value="value" :disabled="disabled"-->
    <!--           :size="size"-->
    <!--           @on-change="update"-->
    <!--    ></Input>-->
    <InputNumber
      ref="input"
      :value="value"
      :size="size"
      :max="max"
      :min="min"
      @on-change="onchange"
    ></InputNumber>


  </div>
</template>
<script>
  export default {
    name: "PriceInput",
    props: {
      disabled: {
        type: Boolean,
        default: false
      },
      size: {
        type: String,
        default: 'default'

      },
      value: {
        type: [Number, String],
        default: 0
      },
      max: {
        type: Number,
        default: 100

      },
      min: {
        type: Number,
        default: 0
      },
      limit: {
        type: Number,
        default: null
      },
      oriValue: {
        type: [Number, String],
        default: 0
      },

    },
    data() {
      return {
        rangeTimer: null,
        blackTimer: null

      }
    },
    methods: {
      onchange(value) {
        if (value === '') {
          this.$emit('input', "")
          return
        }
        if (this.limit === null) {
          this.$emit('input', value)
          return
        }

        if (!this.limitF(value)) {
          this.$emit('input', this.value)
          this.$refs['input'].setValue(this.value)
        } else {
          this.$emit('input', value)
        }
      },
      limitF(value) {
        // let pattern = /^(\d+)(\.\d{0,2})?$/

        let str = '^(\\d+)(\\.\\d{0,' + this.limit + '})?$'
        let re = new RegExp(str)
        return re.test(value)
      }
    }
  }
</script>

<style scoped>

  .wrapper {
    display: inline-block;
    /*background-color: #5aaaff;*/
  }


</style>

